var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.anyesc}},[_c('vue-scroll',{class:{active: _vm.showActive}},[_c('div',{staticClass:"app"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }